<!--
 * @Description: 流程审批代理
 * @Autor: lwq
 * @Date: 2020-07-29 09:31:57
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-11-08 10:53:42
 * @FilePath: \mrc-base-server-view\src\views\approver\index.vue
-->
<template>
  <div>
    <mrc_ess_table :headers="headers" v-if="$route.name == 'approver'" pageName="addApprover"
      :hideAddBtn="!hasBtn('add-on-behalf-approval-configuration-')" :paginationOptions="paginationOptions"
      @turnPage="getList" :isLoading="loading" :slotKey="['effective_start', 'agent_staff_uuid']" :items="desserts">
      <template v-slot:search>
        <v-row class="d-flex justify-end" style="background: white;
          margin: 0;
          border-top-right-radius: 8px;
          border-top-left-radius: 8px;padding: 0 16px">
          <mrc_ess_advanceFilterAndSearchInput class="mt-4" v-model="systemSeniorQueryString"
            @success="getList({ cpage: 1 })" :systemFieldMeta="systemFieldMeta"></mrc_ess_advanceFilterAndSearchInput>
        </v-row>
      </template>
      <template v-slot:item.agent_staff_uuid="{ item }">
        <mrc_ess_staffListView itemValue="user_id" :staffuuid="item.agent_staff_uuid" :allList="allList">
        </mrc_ess_staffListView>
      </template>
      <template v-slot:item.effective_start="{ item }">
        {{ item.effective_start | changeDate() }}
        <span class="mx-1">-</span>
        {{ item.effective_end | changeDate() }}
      </template>
      <template v-slot:item.actions="{ item }">
        <menu-list @handleClick="handleClick($event, item)" :list="[
          {
            name: $t('label_View'),
            type: 'view',
            show: hasBtn('view-on-behalf-approval-configuration'),
          },
          {
            name: $t('label_Edit'),
            type: 'edit',
            show: hasBtn('edit-on-behalf-approval-configuration-entry'),
          },
          {
            name: $t('label_delete'),
            type: 'del',
            show: hasBtn('delete-on-behalf-approval-configuration-entry'),
          },
        ]">
          <template v-slot:showAction>
            <v-icon v-btnAuth="[
              'view--on-behalf-approval-configuration',
              'edit-on-behalf-approval-configuration-entry',
              'delete-on-behalf-approval-configuration-entry',
            ]">mdi-dots-vertical</v-icon>
          </template>
        </menu-list>
      </template>
    </mrc_ess_table>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import { getStaffListForFilter } from "@/service/api/autoComplete.js"
import { required } from "vuelidate/lib/validators"
import { approverList, delApprover } from "@/service/api/approver"
export default {
  components: {},
  props: {},
  data() {
    return {
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      systemSeniorQueryString: [],
      loading: false,
      paginationOptions: {
        pagesize: this.$store.state.pageSize,
        cpage: this.$store.state.cpage,
        totalcount: 0, //总条数
        totalpage: 0, //总页数
      },
      allList: [],
      desserts: [],
    }
  },
  validations: {},
  computed: {
    headers() {
      return [
        {
          text: this.$t("label_The_acting_employee"),
          align: "start",
          sortable: false,
          value: "agent_staff_uuid",
        },
        {
          text: this.$t("label_Date"),
          align: "start",
          sortable: false,
          value: "effective_start",
        },
        {
          text: " ",
          align: "end",
          sortable: false,
          value: "actions",
        },
      ]
    },
    list() {
      return [
        {
          name: this.$t("label_Edit"),
        },
        {
          name: this.$t("label_delete"),
        },
      ]
    },
  },
  beforeDestroy() {
    this.$ls.remove("staffList")
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1)
  },
  async created() {
    await this.getBtnPermissionList()
  },
  watch: {
    async $route(val) {
      if (val.name == "approver") {
        await this.getList(this.paginationOptions)
      }
    },
  },
  async mounted() {
    this.loading = true
    await this.getdropDownList()
    await this.getList(this.paginationOptions)
    this.loading = false
  },
  methods: {
    async getdropDownList() {
      const res = await getStaffListForFilter({
        org_level_uuid: this.$store.state.currentCompany,
      })
      if (res.code == 200) {
        this.allList = res.data
      }
    },
    async getList(obj) {
      if (
        this.desserts &&
        this.desserts.length == 1 &&
        this.paginationOptions.cpage != 1 &&
        this.$route.params.type == "del"
      )
        this.paginationOptions.cpage--
      if (obj) {
        this.paginationOptions = { ...this.paginationOptions, ...obj }
      }
      this.loading = true
      const res = await approverList({
        cpage: this.paginationOptions.cpage,
        pagesize: this.paginationOptions.pagesize,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      })
      if (res.code == 200) {
        this.desserts = res.data
        this.paginationOptions.totalcount = res.totalcount
        this.paginationOptions.totalpage = res.totalpage
        this.systemFieldMeta = res.systemFieldMeta
        this.field_alias_name = res.field_alias_name
        this.table_alias_name = res.table_alias_name
      }
      this.loading = false
    },
    /**
     * @description: 进入详情
     * @param {index} 点的第几个menu
     * @param {item} 点的整条数据
     * @return:
     * @author: lwq
     */
    handleClick({ item, index }, obj) {
      if (item.type == "view") {
        this.$store.commit("set_subPage_name", obj.agent_staff_uuid)
        this.$store.commit("set_uuid", obj.uuid)
        this.$store.commit("set_iconstatus", true)
        this.$router.push({
          name: "detailApprover",
          params: {
            name: obj.agent_staff_uuid,
            uuid: obj.uuid,
          },
        })
      }
      if (item.type == "edit") {
        this.$store.commit("set_subPage_name", obj.agent_staff_uuid)
        this.$store.commit("set_uuid", obj.uuid)
        this.$store.commit("set_iconstatus", false)
        this.$router.push({
          name: "detailApprover",
          params: {
            name: obj.agent_staff_uuid,
            uuid: obj.uuid,
          },
        })
      }
      if (item.type == "del") {
        this.$myConfirm({ content: this.$t("message_Confirm_the_deletion") })
          .then(async () => {
            const del = await delApprover({
              uuid: obj.uuid,
            })
            if (del.code == 200) {
              this.$Message({
                text: this.$t("message_The_deletion_was_successful"),
              })
              // this.desserts.length === 1  只有一条数据 删除就请求上一页的数据
              if (
                this.desserts.length === 1 &&
                this.paginationOptions.cpage > 1
              ) {
                this.paginationOptions.cpage--
              }
              await this.getList()
            }
          })
          .catch(() => { })
      }
    },
  },
}
</script>

<style scoped></style>
